// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__nzqjz","log":"ModalInventoryLogs_log__35VWe","date":"ModalInventoryLogs_date__3dFiO","userName":"ModalInventoryLogs_userName__2-1EE"};